import { render } from "./CustomSelectOnePostCategory.vue?vue&type=template&id=bff1c214&scoped=true"
import script from "./CustomSelectOnePostCategory.vue?vue&type=script&lang=js"
export * from "./CustomSelectOnePostCategory.vue?vue&type=script&lang=js"

import "./CustomSelectOnePostCategory.vue?vue&type=style&index=0&id=bff1c214&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bff1c214"]])

export default __exports__